import PermissionTypes from 'invision-core/src/components/security/permission.types';
export var ACTIVE_SESSION_ACCESS = {
  id: 2016,
  type: PermissionTypes.BOOLEAN
};
export var AD_HOC_OVERRIDE = {
  id: 2021,
  type: PermissionTypes.BOOLEAN
};
export var ADDRESS_ACCESS = {
  id: 2004,
  type: PermissionTypes.SECURITY
};
export var ADDRESS_OVERRIDE_ACCESS = {
  id: 2022,
  type: PermissionTypes.SECURITY
};
export var ADJUSTMENT_LIMIT_AND_ACCESS = {
  id: 196,
  type: PermissionTypes.SECURITY
};
export var FINANCE_ADJUSTMENT_LIMIT_AND_ACCESS = {
  id: 208,
  type: PermissionTypes.SECURITY
};
export var ANNOUNCEMENT_ADMIN_ACCESS = {
  id: 8,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIBER_ANONYMIZATION_ACCESS = {
  id: 134,
  type: PermissionTypes.BOOLEAN
};
export var ANONYMIZE_SUBSCRIBER_IMMEDIATELY_ACCESS = {
  id: 147,
  type: PermissionTypes.BOOLEAN
};
export var BATCH_PAYMENTS_ACCESS = {
  id: 2009,
  type: PermissionTypes.BOOLEAN
};
export var BILL_CYCLE_CHANGE_ACCESS = {
  id: 217,
  type: PermissionTypes.BOOLEAN
};
export var BULK_ENTITLEMENT_OVERRIDE_ACCESS = {
  id: 181,
  type: PermissionTypes.BOOLEAN
};
export var PRICE_OVERRIDE_ACCESS = {
  id: 180,
  type: PermissionTypes.BOOLEAN
};
export var BYPASS_PAYMENT_INSTRUMENT_REQUIRED = {
  id: 112,
  type: PermissionTypes.BOOLEAN
};
export var CANCEL_ORDER_ACCESS = {
  id: 77,
  type: PermissionTypes.BOOLEAN
};
export var CASE_ACCESS = {
  id: 198,
  type: PermissionTypes.SECURITY
};
export var CODE_TABLE_ADMINISTRATION_ACCESS = {
  id: 5,
  type: PermissionTypes.SECURITY
};
export var CONFIGURE_DEVICE_VERSION_SETTINGS = {
  id: 1711,
  type: PermissionTypes.BOOLEAN
};
export var CONVIVA_ACCESS = {
  id: 2015,
  type: PermissionTypes.BOOLEAN
};
export var CONVERGENT_BILLER_ACCESS = {
  id: 9200,
  type: PermissionTypes.BOOLEAN
};
export var CONVERGENT_BILLER_DEMO_ACCESS = {
  id: 9201,
  type: PermissionTypes.BOOLEAN
};
export var COUPON_ACCESS = {
  id: 2013,
  type: PermissionTypes.BOOLEAN
};
export var COUPON_GRANT = {
  id: 49,
  type: PermissionTypes.BOOLEAN
};
export var COUPON_REDEMPTION_CODE_UPDATE_ACCESS = {
  id: 2014,
  type: PermissionTypes.BOOLEAN
};
export var COUPON_REDEMPTION_CODE_VIEW_ACCESS = {
  id: 125,
  type: PermissionTypes.BOOLEAN
};
export var CREDIT_CLASS_VIEW_ACCESS = {
  id: 2032,
  type: PermissionTypes.SECURITY
};
export var DEVICE_ACCESS = {
  id: 2012,
  type: PermissionTypes.BOOLEAN
};
export var DEVICE_MANAGEMENT_ACCESS = {
  id: 98,
  type: PermissionTypes.SECURITY
};
export var DEVICE_PAIR_SMARTCARD_ACCESS = {
  id: 118,
  type: PermissionTypes.BOOLEAN
};
export var DISCOUNT_OVERRIDE_ACCESS = {
  id: 206,
  type: PermissionTypes.BOOLEAN
};
export var E_WALLET_ACCESS = {
  id: 2003,
  type: PermissionTypes.BOOLEAN
};
export var E_WALLET_ADMIN_ACCESS = {
  id: 12,
  type: PermissionTypes.SECURITY
};
export var EARLY_TERMINATION_FEE_OVERRIDE_ACCESS = {
  id: 192,
  type: PermissionTypes.BOOLEAN
};
export var ENTITLEMENT_ACCESS = {
  id: 80,
  type: PermissionTypes.SECURITY
};
export var EXTERNAL_BILL_ADMIN_ACCESS = {
  id: 141,
  type: PermissionTypes.BOOLEAN
};
export var GENERAL_LEDGER_ACCESS = {
  id: 3003,
  type: PermissionTypes.BOOLEAN
};
export var GIFT_CARD_ACCESS = {
  id: 2011,
  type: PermissionTypes.BOOLEAN
};
export var GRANT_ADDITIONAL_RIGHTS = {
  id: 88,
  type: PermissionTypes.BOOLEAN
};
export var GROUP_ADMIN_ACCESS = {
  id: 3,
  type: PermissionTypes.SECURITY
};
export var HOUSEHOLD_ACCESS = {
  id: 2002,
  type: PermissionTypes.BOOLEAN
};
export var HOUSEHOLD_ADMIN_ACCESS = {
  id: 11,
  type: PermissionTypes.SECURITY
};
export var INITIALIZE_DEVICE_ACCESS = {
  id: 122,
  type: PermissionTypes.BOOLEAN
};
export var ISSUE_CREDIT_BRANDABLE_CURRENCY_LIMIT = {
  id: 71,
  type: PermissionTypes.LIMIT
};
export var ISSUE_CREDIT_BRANDABLE_CURRENCY_LIMIT_PER_MONTH = {
  id: 73,
  type: PermissionTypes.LIMIT
};
export var ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT = {
  id: 70,
  type: PermissionTypes.LIMIT
};
export var ISSUE_CREDIT_STANDARD_CURRENCY_LIMIT_PER_MONTH = {
  id: 72,
  type: PermissionTypes.LIMIT
};
export var ISSUE_CREDIT_TO_ALTERNATE_PAYMENT_INSTRUMENT = {
  id: 82,
  type: PermissionTypes.BOOLEAN
};
export var ISSUE_DISCRETIONARY_DISCOUNT = {
  id: 83,
  type: PermissionTypes.BOOLEAN
};
export var ISSUE_WRITE_OFF = {
  id: 74,
  type: PermissionTypes.BOOLEAN
};
export var MEMBER_REPORTS_ACCESS = {
  id: 4001,
  type: PermissionTypes.BOOLEAN
};
export var MULTIPLE_DISCOUNT_ACCESS = {
  id: 2030,
  type: PermissionTypes.BOOLEAN
};
export var ORDER_ACCESS = {
  id: 2005,
  type: PermissionTypes.BOOLEAN
};
export var ORDERING_ACCESS = {
  id: 29,
  type: PermissionTypes.SECURITY
};
export var OVERRIDE_BILLING_EFFECTIVE_DATE = {
  id: 2031,
  type: PermissionTypes.BOOLEAN
};
export var OVERRIDE_OFFER_QUALIFICATION_ENFORCEMENT = {
  id: 2019,
  type: PermissionTypes.BOOLEAN
};
export var PAYMENT_ACCESS = {
  id: 2008,
  type: PermissionTypes.BOOLEAN
};
export var PAYMENT_ACTIVITY_VIEW_ACCESS = {
  id: 117,
  type: PermissionTypes.BOOLEAN
};
export var PAYMENT_ADJUSTMENT_ACCESS = {
  id: 190,
  type: PermissionTypes.BOOLEAN
};
export var PAYMENT_INSTRUMENT_ADMIN_ACCESS = {
  id: 144,
  type: PermissionTypes.BOOLEAN
};
export var PAYMENT_INSTRUMENT_BLOCKLIST_ADMIN_ACCESS = {
  id: 130,
  type: PermissionTypes.SECURITY
};
export var PAYMENT_INSTRUMENT_ALLOWLIST_ADMIN_ACCESS = {
  id: 131,
  type: PermissionTypes.SECURITY
};
export var PLAYER_ADMIN_ACCESS = {
  id: 86,
  type: PermissionTypes.SECURITY
};
export var PORTAL_ACCESS = {
  id: 2000,
  type: PermissionTypes.BOOLEAN
};
export var PORTAL_ADMIN_ACCESS = {
  id: 6,
  type: PermissionTypes.SECURITY
};
export var PRODUCTS_ACCESS = {
  id: 2007,
  type: PermissionTypes.BOOLEAN
};
export var REFUND_LIMIT_AND_ACCESS = {
  id: 201,
  type: PermissionTypes.SECURITY
};
export var REMARK_ADMIN_ACCESS = {
  id: 14,
  type: PermissionTypes.SECURITY
};
export var REMARK_ATTACHMENT_SIZE_LIMIT = {
  id: 17,
  type: PermissionTypes.LIMIT
};
export var REMARK_EXTERNAL_ADMIN_ACCESS = {
  id: 15,
  type: PermissionTypes.SECURITY
};
export var REMARK_OVERWRITE_ADMIN_ACCESS = {
  id: 16,
  type: PermissionTypes.SECURITY
};
export var REMARK_UPDATE_AS_READ = {
  id: 18,
  type: PermissionTypes.BOOLEAN
};
export var RENEW_ORDER_WITHOUT_CHARGE_ACCESS = {
  id: 31,
  type: PermissionTypes.BOOLEAN
};
export var RESEND_GIFT_CARD_ACCESS = {
  id: 19,
  type: PermissionTypes.BOOLEAN
};
export var RESET_SUBSCRIBER_PASSWORD_ACCESS = {
  id: 37,
  type: PermissionTypes.BOOLEAN
};
export var RESET_USER_PASSWORD_ACCESS = {
  id: 119,
  type: PermissionTypes.BOOLEAN
};
export var RESUBMIT_ORDER_ACCESS = {
  id: 78,
  type: PermissionTypes.BOOLEAN
};
export var RETURN_DEVICE_ACCESS = {
  id: 205,
  type: PermissionTypes.BOOLEAN
};
export var ROLE_ADMIN_ACCESS = {
  id: 2,
  type: PermissionTypes.SECURITY
};
export var SEND_EMAIL = {
  id: 39,
  type: PermissionTypes.BOOLEAN
};
export var SEND_GIFT_ORDER_ACCESS = {
  id: 139,
  type: PermissionTypes.BOOLEAN
};
export var SEND_TRANSACTION_RECEIPT_ACCESS = {
  id: 138,
  type: PermissionTypes.BOOLEAN
};
export var SPECIFY_EXTERNAL_SKU = {
  id: 65,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIBER_ACCESS = {
  id: 2001,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIBER_ADMIN_ACCESS = {
  id: 10,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIBER_NETOWRK_SUSPENSION = {
  id: 2026,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_BILLING_AND_NETOWRK_SUSPENSION = {
  id: 2025,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_FINANCE_INSTALLMENT_SUSPEND_AND_RESUME_ACCESS = {
  id: 2027,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_BYPASS_RESET_PASSWORD = {
  id: 194,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_CREATE = {
  id: 136,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_FIND = {
  id: 13,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_PASSWORD_CHALLENGE_RESPONSE_ACCESS = {
  id: 111,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_PRODUCT_REMOVE_DISCOUNT_ACCESS = {
  id: 113,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_REMOVE = {
  id: 135,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_TYPE_ACCESS = {
  id: 104,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_TYPE_EDIT_ACCESS = {
  id: 2024,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIPTION_ACCESS = {
  id: 2006,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIPTION_REMOVE_ADJUSTMENT = {
  id: 63,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIPTION_TERMINATION_FEE_WAIVER = {
  id: 38,
  type: PermissionTypes.BOOLEAN
};
export var TICKET_ACCESS = {
  id: 2010,
  type: PermissionTypes.BOOLEAN
};
export var TRANSFER_SERVICES = {
  id: 211,
  type: PermissionTypes.SECURITY
};
export var TROUBLE_MANAGEMENT_ADMIN_ACCESS = {
  id: 96,
  type: PermissionTypes.SECURITY
};
export var UPDATE_PIN_ACCESS = {
  id: 215,
  type: PermissionTypes.SECURITY
};
export var UPDATE_SERVICE_LIFECYCLE_STATUS = {
  id: 227,
  type: PermissionTypes.SECURITY
};
export var USER_ROLE_AND_GROUP_ASSIGNMENT_ACCESS = {
  id: 137,
  type: PermissionTypes.SECURITY
};
export var VIEW_FUTURE_INVOICES_ACCESS = {
  id: 2033,
  type: PermissionTypes.BOOLEAN
};
export var VIEW_INVOICE_DROPDOWN_ACCESS = {
  id: 218,
  type: PermissionTypes.BOOLEAN
};
export var WORKFLOW_CANCEL_ACCESS = {
  id: 24,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_CHANGE_EXECUTION_ACCESS = {
  id: 25,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_COMPLETE_ACTIVITY_MANUALLY_ACCESS = {
  id: 22,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_EXECUTION_ACCESS = {
  id: 20,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_EXECUTION_ACTIVITY_ASSIGNMENT_ACCESS = {
  id: 27,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_EXECUTION_HISTORY_ACCESS = {
  id: 26,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_EXECUTION_PRIORITY = {
  id: 28,
  type: PermissionTypes.SECURITY
};
export var WORKFLOW_RESTART_ACCESS = {
  id: 23,
  type: PermissionTypes.SECURITY
};
export var ENTITLEMENT_BALANCE_UPDATE_ACCESS = {
  id: 2035,
  type: PermissionTypes.BOOLEAN
};
export var ALLOW_CREDIT_DEBIT_NOTE = {
  id: 224,
  type: PermissionTypes.BOOLEAN
};
export var ONE_TIME_MAKE_PAYMENT = {
  id: 2034,
  type: PermissionTypes.BOOLEAN
};
export var DISPUTE_INVOICE = {
  id: 198,
  type: PermissionTypes.BOOLEAN
};
export var RATE_SHEET_EDIT_ACCESS = {
  id: 2036,
  type: PermissionTypes.BOOLEAN
};
export var POLICY_COUNTERS_EDIT_ACCESS = {
  id: 2037,
  type: PermissionTypes.BOOLEAN
};
export var FEES_EDIT_ACCESS = {
  id: 2038,
  type: PermissionTypes.SECURITY
};
export var NOTIFICATIONS_ACCESS = {
  id: 303,
  type: PermissionTypes.BOOLEAN
};
export var PII_ACCESS = {
  id: 406,
  type: PermissionTypes.BOOLEAN
};
export var SUBSCRIBER_TREATMENT_ACCESS = {
  id: 2045,
  type: PermissionTypes.SECURITY
};
export var SUBSCRIBER_HIERARCHY_ACCESS = {
  id: 2046,
  type: PermissionTypes.SECURITY
};
export var ORDER_HISTORY_ACCESS = {
  id: 2048,
  type: PermissionTypes.SECURITY
};
export var ALLOW_REMOVAL_OF_OFFERINGS = {
  id: 603,
  type: PermissionTypes.SECURITY
};